import { render } from "./section_5.vue?vue&type=template&id=ecf003dc"
import script from "./section_5.vue?vue&type=script&lang=js"
export * from "./section_5.vue?vue&type=script&lang=js"

import "./section_5.vue?vue&type=style&index=0&id=ecf003dc&lang=css"
script.render = render

export default script